import { RouteObject, Navigate } from "react-router-dom";
import AdminRoot from "../components/roots/admin-root/AdminRoot";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login";
import Languages from "../pages/languages/Languages";
import Categories from "../pages/categories/Categories";
import Settings from "../pages/settings/Settings";
import Admins from "../pages/admins/Admins";
import Products from "../pages/products/Products";
import Brands from "../pages/brands/Brands";
import Countries from "../pages/countries/Countries";
import Partners from "../pages/partners/Partners";
import News from "../pages/news/News";
import Colors from "../pages/colors/Colors";
import Pages from "../pages/pages/Pages";
import Dictionary from "../pages/dictionary/Dictionary";
import NotFound from "../pages/not-found/NotFound";
import CategorySpecs from "../pages/category-specs/CategorySpecs";
import Permissions from "../pages/permissions/Permissons";
import Campaigns from "../pages/campaigns/Campaigns";
import Services from "../pages/services/Services";
import { getCookie } from "../utils/utils";
import GroupNames from "../pages/group-names/GroupNames";
import Vacancy from "../pages/vacancy/Vacancy";
import Blogs from "../pages/blogs/Blogs";
import Video from "../pages/vidoe/Video";
import Branchs from "../pages/branchs/Branchs";
import Contact from "../pages/contact/Contact";
import Subscribers from "../pages/subscribers/Subscribers";
import RepairOrder from "../pages/repair-order/RepairOrder";
import Warehouse from "../pages/warehouse/Warehouse";
import WeeklyPicks from "../pages/weekly-picks/WeeklyPicks";
import ServicesGroup from "../pages/services-group/ServicesGroup";
import OrderStatus from "../pages/order-status/OrderStatus";
import About from "../pages/about/About";
import ProductOrders from "../pages/product_orders/ProductOrders";
import ServiceOrders from "../pages/service_orders/ServiceOrders";
import AccessoryOrders from "../pages/accessory_orders/AccessoryOrders";
import QuickOrders from "../pages/quick-orders/QuickOrders";
import OfficialService from "../pages/official-service/OfficialService";
import InstallOrders from "../pages/install-orders/InstallOrders";
import WarrantyTerms from "../pages/warrantyTerms/WarrantyTerms";
import ChatbotTemplates from "../pages/chatbot-templates/ChatbotTemplates";
import LiveSupport from "../pages/live-support/LiveSupport";
import Messaging from "../pages/messaging/Messaging";

const token = getCookie("BscAdminToken");
const ROUTES: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={`${token ? "/admin" : "login"}`} replace />,
  },
  {
    path: "/admin",
    element: <AdminRoot />,
    children: [
      {
        path: "/admin/",
        element: <Dashboard />,
      },
      {
        path: "admins",
        element: <Admins />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "languages",
        element: <Languages />,
      },
      {
        path: "categories",
        element: <Categories />,
      },
      {
        path: "products",
        element: <Products />,
      },
      {
        path: "brands",
        element: <Brands />,
      },
      {
        path: "countries",
        element: <Countries />,
      },
      {
        path: "partners",
        element: <Partners />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "colors",
        element: <Colors />,
      },
      {
        path: "pages",
        element: <Pages />,
      },
      {
        path: "dictionary",
        element: <Dictionary />,
      },
      {
        path: "category-specs",
        element: <CategorySpecs />,
      },
      {
        path: "permissions",
        element: <Permissions />,
      },
      {
        path: "campaigns",
        element: <Campaigns />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "category-specs-group-names",
        element: <GroupNames />,
      },
      {
        path: "vacancy",
        element: <Vacancy />,
      },
      {
        path: "blogs",
        element: <Blogs />,
      },
      {
        path: "video",
        element: <Video />,
      },
      {
        path: "branchs",
        element: <Branchs />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "subscribers",
        element: <Subscribers />,
      },
      {
        path: "repair_order",
        element: <RepairOrder />,
      },
      {
        path: "warehouse",
        element: <Warehouse />,
      },
      {
        path: "weekly_picks_products",
        element: <WeeklyPicks />,
      },
      {
        path: "services_groups",
        element: <ServicesGroup />,
      },
      {
        path: "order_status",
        element: <OrderStatus />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "product_orders",
        element: <ProductOrders />,
      },
      {
        path: "service_orders",
        element: <ServiceOrders />,
      },
      {
        path: "install_orders",
        element: <InstallOrders />,
      },
      {
        path: "accessory_orders",
        element: <AccessoryOrders />,
      },
      {
        path: "quick_orders",
        element: <QuickOrders />,
      },
      {
        path: "official_service",
        element: <OfficialService />,
      },
      {
        path: "warranty-terms",
        element: <WarrantyTerms />,
      },
      {
        path: "chatbot-templates",
        element: <ChatbotTemplates />,
      },
      {
        path: "live-support",
        element: <LiveSupport />,
      },
      {
        path: "live-support/messaging/:id",
        element: <Messaging />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default ROUTES;
